// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","header":"header-22Aqk","heading":"heading-356sq"};